import { IAttachments } from 'app/pages/request-single-page/request-single-page-slice';
import { MediaItem } from '../media.types';
import { MIME_MAP } from '../media.constants';
import { GW_SERVICES_PREFIXES } from 'app/constants/gateway';

export const convertToMediaFile = (files: IAttachments[]): MediaItem[] => {
  return files.map((file) => {
    const parts = file.file_name.split('.');
    const extension =
      parts.length > 1 ? parts.pop()?.toLowerCase() ?? 'unknown' : 'unknown';
    const mimeType =
      MIME_MAP[extension as keyof typeof MIME_MAP] ?? MIME_MAP.unknown;
    const type = (mimeType.split('/')?.[0] as MediaItem['type']) || 'other';

    return {
      id: file.id,
      name: file.file_name,
      extension,
      mimeType,
      type,
      src: `${GW_SERVICES_PREFIXES.FILES}/files/${file.id}/`,
    };
  });
};
